import axios from "axios";
import {detailServicesPath} from "../../../Constants";

const detailControllerRestUrl = detailServicesPath + '/customers/orders/'

export default class GrooveControllerService {
    static async add(orderId,detailId, data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.post(`${detailControllerRestUrl}${orderId}/details/${detailId}/grooves${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async delete(orderId,detailId, grooveId) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.delete(`${detailControllerRestUrl}${orderId}/details/${detailId}/grooves/${grooveId}${params}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }

    static async put(orderId,detailId, grooveId,data) {
        const params = orderId === 0 ? "?sample=true" : ""
        return await axios.put(`${detailControllerRestUrl}${orderId}/details/${detailId}/grooves/${grooveId}${params}`, JSON.stringify(data), {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
